import { render, staticRenderFns } from "./ProtocoloEmpresa.vue?vue&type=template&id=89349984&scoped=true&lang=pug"
import script from "./ProtocoloEmpresa.vue?vue&type=script&lang=js"
export * from "./ProtocoloEmpresa.vue?vue&type=script&lang=js"
import style0 from "./ProtocoloEmpresa.vue?vue&type=style&index=0&id=89349984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89349984",
  null
  
)

export default component.exports